import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {Modal, Button} from 'react-bootstrap'
import FormGroup from "live/components/forms/ui/form-group";

import TabContainer from "../TabContainer";

import List from "./list/List";
import Perspective from "./perspective/Perspective";

import { fetchApi } from "../../api/fetchApi";
import { deletePerspectiveOfCompany } from "../../api/companyApi";
import { listPerspectivesApi } from "../../api/perspectiveApi";

const PerspectiveAdministration = ({ height, company }) => {
  const [perspectiveList, setPerspectiveList] = useState([]);
  const [perspectiveSelected, setPerspectiveSelected] = useState(null);
  const [objectToDelete, setObjectToDelete] = useState({})
  

  useEffect(() => {
    
    company.id
      ? reloadPerspectiveList()
      : null;
  }, [company.id]);


  const reloadPerspectiveList = () => {
    listPerspectivesApi(company.id)
    .then((response) => {
        setPerspectiveList(response.data);
    })
  }

  const confirmDeleteObject = (objectToDelete) => {
    setObjectToDelete(objectToDelete);
    
  };

  const selectPerspective = (perspective) => {
    setPerspectiveSelected(perspective);
  };

  const newPerspective = () => {
    setPerspectiveSelected({})
  }

  const cancelEdition = () => {
    setPerspectiveSelected(null);
  }

  const deletePerspective = () => {
    deletePerspectiveOfCompany(company.id, objectToDelete.id)
    .then((response) => {
        setObjectToDelete({});
        reloadPerspectiveList();
    });
  }

  

  return (
    <TabContainer height={height}>
      <AdmMainContainer>
      {
              objectToDelete.id ? 
              <DeleteModal
              onHide={null}
              cancel={confirmDeleteObject}
              remove={deletePerspective}
              objectToDelete={objectToDelete}/> 
              
              :null
            }
        {perspectiveSelected ? (
          <Perspective 
          perspective={perspectiveSelected} 
          company={company}
          selectPerspective={selectPerspective}
          reloadPerspectiveList={reloadPerspectiveList}/>
        ) : (
          <List 
          items={perspectiveList.filter((perspective) => {return perspective.id != company.perspectiveId})} 
          selectPerspective={selectPerspective}
          newPerspective={newPerspective}
          deleteObject={confirmDeleteObject}/>
        )}
      </AdmMainContainer>
    </TabContainer>
  )
};

const AdmMainContainer = styled.div`
  display: flex;
  
  height: calc(100% - 10px);

  /* border:5px solid yellow; */
`;

export default PerspectiveAdministration;


const DeleteModal = ({show, onHide, objectToDelete, cancel,remove}) => {

  const [textTyped, setTextTyped] = useState(null);
  const [textToConfirm, setTextToConfirm] = useState("");
  const refContainer = useRef(null);

  useEffect(() => {
    if(objectToDelete){
      setTextToConfirm("REMOVE " + objectToDelete.name.toUpperCase())
    }

  }, [objectToDelete])

  textTyped ? refContainer.current.focus() : null;


  const DeleteModal = styled.div`
    .title-message{
      font-size: 1.8rem; 
      color:#d90000;
      font-weight:900;
    }

    .important-message{
      font-size: 1.6rem; 
      color:#d90000;
      font-weight:700;
      padding:20px;
    }

    .normal-text{
      font-size: 1.5rem ; 
      
    }

    .danger-button{
      background-color:#d90000;
      color:white;

      
    }


  `

  const handleInputTextChange = (value) => {
    setTextTyped(value);
  }

  const checkIfTheTextIsCorrect= () => {

    if(textTyped === textToConfirm){
      remove()
    }
  }

  return (
    
      <Modal show={true} onHide={() => cancel({})} autoFocus={false}>
        <DeleteModal>
        <Modal.Header closeButton>
            
          <Modal.Title><div className="title-message"> <i class="fas fa-exclamation-circle"/> Attention!</div></Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="normal-text">
          Are you sure you want remove this perspective?
        </div>
        <div className="important-message">

          This action cannot be undone.<br/>
          With the perspective, will be removed dashboards, rules and datasources associeted to it. 
        </div>
        <div className="normal-text">
        If you really want to delete the perspective, type <span  style={{"color":"red", "font-weight":"700"}}>{textToConfirm}</span> in the field below before completing the action:
        </div>
        <input autoFocus={true} ref={refContainer} type="text" value={textTyped} onChange={(e) => {setTextTyped(e.target.value)}}/>

        </Modal.Body>
        <Modal.Footer>
          <Button className="danger-button" variant="danger" onClick={() => {checkIfTheTextIsCorrect()}}>
            Remove
          </Button>
          <Button onClick={() => {cancel({})}}>
            Cancel
          </Button>
        </Modal.Footer>
        </DeleteModal>
      </Modal>
  )

  
}
